export const ATTRIBUTE_CARD = {
	CONTEXT: "Context",
	DETAILED: "Detailed",
	SLIM: "Slim",
} as const;

export type AttributeCardType = typeof ATTRIBUTE_CARD[keyof typeof ATTRIBUTE_CARD];
